import { QuestionnaireAnswersResponse } from "../../types"
import { createJoonAPIClient } from "../../util/joon-api"

export const getClientQuestionnaire = async (userId: number) => {
  const API = createJoonAPIClient()

  const response = await API.get<{ results: QuestionnaireAnswersResponse[] }>(
    `api/questionnaire-responses/`,
    {
      params: { user_id: userId },
    }
  )

  return response.data.results
}
